import _ from 'lodash'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import template from './text-filter.hbs'
import HasOperatorsFilter from './has-operators-filter'
import DataType from 'scoreboard/datasets/model/data-type'
const { TEXT } = DataType

var TextFilter = HasOperatorsFilter.extend({

	//this.data is a TextFilter which is just a plain object containing data
	//about text filters that is associated with a report

	className: 'report-filters text-filter filter',

	initialize: function(opts = {}) {
		opts.dataType = TEXT
		HasOperatorsFilter.prototype.initialize.apply(this, arguments)
	},

	_renderAdditionalControls: function() {
		this.$el.append(template)

		//add error tooltips
		this._textMarkedField = new MarkedField({
			el: this.$('input:text'),
			validator: requiredValidator
		}).render()

		if (this._isHidingValues() && !_.isEmpty(this.data.values)) {
			this._textMarkedField.val(this.data.values[0])
		}
	},

	/**
	 * Provides validation to this view
	 */
	test: function() {
		return this._isHidingValues() ? this._textMarkedField.test() :
			HasOperatorsFilter.prototype.test.apply(this, arguments)
	},

	//returns the data captured by this filter
	gather: function(e) {
		HasOperatorsFilter.prototype.gather.apply(this, arguments)
		if (this._isHidingValues()) {
			this.data.values = [this._textMarkedField.val()]
		}
		return this.data
	},

	remove: function () {
		HasOperatorsFilter.prototype.remove.apply(this, arguments)
		_.invokeMap([this._textMarkedField], 'remove')
	}

})

export default TextFilter

TextFilter.__filename__ = 'reports/common/filter/text-filter.js'
